var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":_vm.colorDesc,"placement":"top"}},[_c('span',{staticClass:"colored-item",style:({ backgroundColor: _vm.color })})])}
var staticRenderFns = []

export { render, staticRenderFns }